import { AbstractConnector } from './AbstractConnector';
import { AuthServerProvider } from '../providers';
export class AuthServerConnector extends AbstractConnector {
    constructor() {
        super();
        this.activate = async () => {
            const account = this.provider.getAccount();
            if (!account) {
                throw new Error('Cannot activate the Auth Server Connector');
            }
            return {
                provider: this.provider,
                chainId: this.provider.getChainId(),
                account
            };
        };
        this.getProvider = async () => {
            return this.provider;
        };
        this.getChainId = async () => {
            return this.provider.getChainId();
        };
        this.getAccount = async () => {
            return this.provider.getAccount();
        };
        this.provider = new AuthServerProvider();
    }
    deactivate() {
        this.provider.deactivate();
    }
}
//# sourceMappingURL=AuthServerConnector.js.map